<div [id]="idContent">
  <ng-content></ng-content>
</div>
